import { DefaultTheme, FontSize, ThemeProps } from 'styled-components';
import styleUtils from '../style.utils';

enum THEMED_FONT_SIZE_TYPES {
  BODY = 'BODY',
  FORM = 'FORM',
  ERROR = 'ERROR',
  ATTACHMENT_DESC = 'ATTACHMENT_DESC',
  HEADER_TITLE = 'HEADER_TITLE',
  HEADER_TITLE_M = 'HEADER_TITLE_M',
  HEADER_CONTENT = 'HEADER_CONTENT',
  DISPATCH_PAGE_TITLE = 'DISPATCH_PAGE_TITLE',
  DISPATCH_PAGE_TITLE_M = 'DISPATCH_PAGE_TITLE_M',
  DISPATCH_PAGE_TITLE_XS = 'DISPATCH_PAGE_TITLE_XS',
  MOBILE_REDIRECT_BUTTON = 'MOBILE_REDIRECT_BUTTON',
  MOBILE_REDIRECT_BUTTON_XS = 'MOBILE_REDIRECT_BUTTON_XS',
  BUTTON_S = 'BUTTON_S',
  BUTTON_M = 'BUTTON_M',
  BUTTON_L = 'BUTTON_L'
}

const themedFontSize = (fontSize: FontSize) => (
  props: ThemeProps<DefaultTheme>
): string => styleUtils.px(props.theme.fontSizes[fontSize]);

const themedLineHeight = (
  lineHeight: number | undefined,
  fontSize: FontSize
) => (props: { theme: DefaultTheme }): string =>
  styleUtils.px(lineHeight || props.theme.fontSizes[fontSize] * 1.5);

export { THEMED_FONT_SIZE_TYPES, themedLineHeight };
export type ThemedFontSizeReturn = ReturnType<typeof themedFontSize>;
export default themedFontSize;
